import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { applicationStore } from "src/store/ApplicationStore";
import logger from "src/utils/logger";
import i18n from "src/i18n";
import { MAX_FILE_SIZE_MB } from "src/constants/fileConfig";

const axiosInstance = axios.create({
    timeout: 120000,
});

// Initialize Accept-Language header with current language
axiosInstance.defaults.headers.common["Accept-Language"] = i18n?.language || "en";

// Keep Accept-Language in sync with language changes
i18n?.on && i18n.on("languageChanged", (lng) => {
    if (lng) {
        axiosInstance.defaults.headers.common["Accept-Language"] = lng;
    }
});

axiosInstance.interceptors.request.use(
    (config) => {
        //istek yapılmadan önce yapılacak işlemler
        // Ensure header is set on each request in case of external instance mutations
        config.headers = config.headers || {};
        config.headers["Accept-Language"] = i18n?.language || config.headers["Accept-Language"] || "en";
        const access_token = applicationStore.access_token
        if (access_token) {
            const decodedToken = jwtDecode(access_token);
            if (decodedToken.exp * 1000 < Date.now()) {
                toast.error("The link has expired. Please request a new link.");
                window.location.href = '/link-expired';
                return Promise.reject(new Error("Token expired"));
            }
        }
        //logger.log('Request Interceptor:', config);
        return config;
    },
    (error) => {
        // İstek hatası
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        // İstek başarılı olduğunda yapılacak işlemler
        //logger.log('Response Interceptor:', response);
        return response;
    },
    (error) => {
        if (!error.response) {
            // CORS hatası veya server'dan yanıt gelmediğinde
            //logger.error('Network error or CORS issue:', error);
            toast.error('An error occurred, please try again later.');
        } else {
            const status = error?.response?.status;
            if (status >= 400 && status < 500) {
                if (status === 404) {
                    toast.error(error.response?.data?.detail?.message);
                    window.location.href = '/not-found';
                } else if (status === 423) {
                    toast.error(error?.response?.data?.detail.message);
                    window.location.href = '/decline';
                } else if (status === 422) {
                    error?.response?.data?.detail.forEach(error => {
                        toast.error(error.msg);
                    });
                } else if (status === 413) {
                    toast.error(`File size exceeds the maximum limit of ${MAX_FILE_SIZE_MB} MB.`);
                } else {
                    // İstemci hataları
                    logger.error(error.response)
                    // toast.error('An error occurred, please try again later.');
                }
            } else if (status === 503) {
                toast.error('The service is currently unavailable. Please try again later.');
            } else if (status >= 500) {
                // Sunucu hataları
                //logger.error('Server error:', error.response);
                toast.error('An error occurred, please try again later');
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
